import React from 'react';

import { ThemeProvider } from '@material-ui/styles';
import theme from './components/theme';

import Header from './components/common-header/Header';
import Hero from './components/Hero';
import Overwhelmed from './components/Overwhelmed';
import PhotoCollage1 from './components/PhotoCollage1';
import Navigating from './components/Navigating';
import PhotoCollage2 from './components/PhotoCollage2';
import PhotoCollage3 from './components/PhotoCollage3';
import LastText from './components/LastText';
import PhotoCollage4 from './components/PhotoCollage4';
import FindingSupport from './components/FindingSupport';
import ComingTogether from './components/ComingTogether';
import Footer from './components/common-footer/Footer';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Header clientName={'UnitedHealthcare'} />
      <Hero />
      <Overwhelmed />
      <PhotoCollage1 />
      <Navigating />
      <PhotoCollage4 />
      <FindingSupport />
      <PhotoCollage2 />
      <ComingTogether />
      <PhotoCollage3 />
      <LastText />
      <Footer />
    </ThemeProvider>
  );
}

export default App;
